const STG_FALLBACK = {
  apiKey: "AIzaSyAHBrDimaOJyZVGx1zA1-pblRoMPnFKxsM",
  authDomain: "due-stg.firebaseapp.com",
  projectId: "due-stg",
  storageBucket: "due-stg.firebasestorage.app",
  messagingSenderId: "1009355885797",
  appId: "1:1009355885797:web:b565c2c91a4ce1b4eb980c",
  measurementId: "G-2VT06B104M",
};

const pick = (value, fallback) => {
  const normalized = (value || "").toString().trim();
  return normalized.length > 0 ? normalized : fallback;
};

export const firebaseConfig = {
  apiKey: pick(process.env.VUE_APP_FIREBASE_API_KEY, STG_FALLBACK.apiKey),
  authDomain: pick(process.env.VUE_APP_FIREBASE_AUTH_DOMAIN, STG_FALLBACK.authDomain),
  projectId: pick(process.env.VUE_APP_FIREBASE_PROJECT_ID, STG_FALLBACK.projectId),
  storageBucket: pick(process.env.VUE_APP_FIREBASE_STORAGE_BUCKET, STG_FALLBACK.storageBucket),
  messagingSenderId: pick(process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID, STG_FALLBACK.messagingSenderId),
  appId: pick(process.env.VUE_APP_FIREBASE_APP_ID, STG_FALLBACK.appId),
  measurementId: pick(process.env.VUE_APP_FIREBASE_MEASUREMENT_ID, STG_FALLBACK.measurementId),
};
